import IResponseParser from '../IResponseParser';
import { AxiosResponse } from 'axios';

export default class PlainResponseParser implements IResponseParser {
  parse(response: AxiosResponse<any>): Promise<any> {
    return new Promise((resolve, reject) => {
      if (!response) {
        reject();
        return;
      }
      const { status, data } = response;
      if (status !== 200) {
        reject();
        return;
      }
      resolve(data);
    });
  }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/utils/http/request/impl/PlainResponseParser.ts